import React from 'react';
import PropTypes from 'prop-types';

import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography} from 'views/components';
import {CaregiverAutocomplete, Translate, translate} from 'views/module';

const NewChannelDialog = (props) => {
  const {
    closeDialog,
    createChannel,
  } = props;

  const [selectedCaregiver, setSelectedCaregiver] = React.useState(null);
  const [isCreating, setIsCreating] = React.useState(false);
  const [createFailed, setCreateFailed] = React.useState(false);

  const onConfirm = async () => {
    if (!selectedCaregiver || isCreating) return;

    setIsCreating(true);
    setCreateFailed(false);

    try {
      await createChannel(selectedCaregiver.caregiverRn);
      closeDialog();
    } catch (error) {
      console.error('Failed to create the support channel:', error);
      setCreateFailed(true);
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <Dialog maxWidth='xs' onClose={closeDialog}>
      <DialogTitle onClose={closeDialog}>
        <Translate expression='inbox.NewChannel.Title' />
      </DialogTitle>
      <DialogContent>
        <Stack sx={{gap: 1.5, pt: 0.5}}>
          <Typography sx={{fontSize: '13px', fontWeight: 400, color: '#63708A'}}>
            <Translate expression='inbox.NewChannel.Description' />
          </Typography>
          <CaregiverAutocomplete
            label={translate('inbox.NewChannel.Caregiver.Label')}
            selectedCaregiver={selectedCaregiver}
            setSelectedCaregiver={setSelectedCaregiver}
            statuses={Object.keys(translate('caregiver.Status'))}
            onClear={() => setSelectedCaregiver(null)}
          />
          {
            createFailed &&
              <Typography sx={{fontSize: '12px', fontWeight: 400, color: 'error.main'}}>
                <Translate expression='inbox.NewChannel.CreateFailed' />
              </Typography>
          }
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button disabled={isCreating} onClick={closeDialog} variant='outlined'>
          <Translate expression='generic.Cancel' />
        </Button>
        <Button disabled={!selectedCaregiver || isCreating} onClick={onConfirm}>
          <Translate expression='inbox.NewChannel.Confirm' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

NewChannelDialog.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  createChannel: PropTypes.func.isRequired,
};

export default React.memo(NewChannelDialog);
